export function warnMissingLoadingAriaLabel(
  component: string,
  isLoading: boolean,
  loadingAriaLabel: string | undefined
) {
  if (
    process.env['NODE_ENV'] !== 'production' &&
    isLoading &&
    !loadingAriaLabel
  ) {
    console.warn(
      `Zeus Next ${component}: \`loadingAriaLabel\` is required when \`isLoading\` is true to provide accessible context for screen readers.`
    );
  }
}
